module.exports = __webpack_public_path__ + "img/nbg.21ebd911.png";